import React, { Component } from 'react';
import { Form, Card, Button } from 'semantic-ui-react';
import get from 'lodash.get';
import * as accountSettingsActions from './reducer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { Record } from '../../../modules/bin/utility';
import RecordResultMessage from '../../../components/common/recordResult';
import { withRouterV6 } from '../../../helpers/withRouterV6.jsx';
import ValidatedInput from '../../../components/common/validatedInput';
import { getPasswordErrorMessage } from '../../../helpers/validationHelper';
import { getPolicyForMemberships } from '../../../constants/passwordPolicy';
import InvalidPassword from '../../../components/authentication/invalidPassword';
import SaveSecurityModal from './MFA/saveSecurityModal';

class UpdatePassword extends Component {
  constructor(props) {
    super(props);
    this.props.clearRecordChangePasswordMessages();
  }
  onNewPasswordChange = (_event, { value }) => {
    this.props.newPasswordChange(value);
  };

  onConfirmPasswordChange = (_event, { value }) => {
    this.props.confirmPasswordChange(value);
  };

  saveChanges = (verificationVariant = null, verificationCode = null) => {
    this.props.updateRecordPassword(
      this.props.id,
      { password: this.props.newPassword },
      verificationVariant,
      verificationCode
    );
  };

  onSaveClick = () => {
    if (this.props.hasMfaActive) {
      this.props.handleValueChange('accountVerification.open', true);
    } else {
      this.saveChanges();
    }
  };

  isSaveButtonDisabled = (passwordErrorMessage) => {
    return (
      passwordErrorMessage !== undefined ||
      this.props.newPassword !== this.props.confirmPassword
    );
  };

  getConfirmPasswordErrorMessage = (password, confirmPassword) => {
    return password !== confirmPassword
      ? I18n.t('errors.validation.password.not-equal')
      : '';
  };

  /**
   * Clear all record messages
   */
  clearMessages = () => {
    this.props.clearRecordChangePasswordMessages();
  };

  handleUpdateError = () => {
    if (this.props.accountVerification.open) {
      this.props.verificationModalClear();
      this.props.clearRecord('recordChangePassword');
    }
  };

  render() {
    const { confirmPassword, newPassword, passwordPolicy } = this.props;
    // The policy of the account being edited, not of whoever is editing: a system administrator
    // can change an ordinary user's password, and vice versa is refused by the API.
    const passwordErrorMessage = getPasswordErrorMessage(
      newPassword,
      passwordPolicy
    );

    const isSuccess = Record.isSuccess(this.props.recordChangePassword);
    const isError = Record.isError(this.props.recordChangePassword);
    const isLoading = Record.isRecordLoading(this.props.recordChangePassword);

    if (isSuccess) {
      this.props.goToPagesList();
    }

    if (isError) {
      this.handleUpdateError();
    }

    return (
      <div>
        <RecordResultMessage
          record={this.props.recordChangePassword}
          onDismiss={this.clearMessages}
        />
        <SaveSecurityModal
          isLoading={isLoading}
          handleVerificationClick={this.saveChanges}
        />
        <div className="general-conatiner">
          <Card fluid style={{ backgroundColor: 'rgba(216, 216, 216, 0.1)' }}>
            <div className="detail-container">
              <Card.Content>
                <Form>
                  <Form.Field width={15}>
                    <ValidatedInput
                      value={newPassword}
                      placeholder="New password"
                      label="New password"
                      onChange={this.onNewPasswordChange}
                      type="password"
                      error={passwordErrorMessage !== undefined}
                      errorComponent={
                        <InvalidPassword errors={passwordErrorMessage} />
                      }
                    />
                  </Form.Field>
                  <Form.Field width={15}>
                    <ValidatedInput
                      value={confirmPassword}
                      placeholder="Confirm password"
                      label="Confirm password"
                      type="password"
                      onChange={this.onConfirmPasswordChange}
                      errorMessage={this.getConfirmPasswordErrorMessage(
                        newPassword,
                        confirmPassword
                      )}
                    />
                  </Form.Field>
                </Form>
                <div className="bottom-space"></div>
              </Card.Content>
            </div>
          </Card>
          <Button
            primary
            style={{ minWidth: '100px' }}
            floated="right"
            disabled={this.isSaveButtonDisabled(passwordErrorMessage)}
            loading={this.props.isLoading}
            onClick={this.onSaveClick}
          >
            <Translate value={'account.update-password.save'} />
          </Button>
          <Button floated="right" onClick={this.props.onCancel}>
            <Translate value={'account.update-password.cancel'} />
          </Button>
        </div>
      </div>
    );
  }
}

const mapState = ({ accountSettings }) => {
  const { confirmPassword, newPassword } = accountSettings;
  const id = accountSettings.record.data.data.id;
  return {
    recordChangePassword: accountSettings.recordChangePassword,
    accountVerification: accountSettings.accountVerification,
    hasMfaActive: get(accountSettings.record.data.data, 'hasMfaActive'),
    passwordPolicy: getPolicyForMemberships(
      get(accountSettings.record.data.data, 'adminMemberships')
    ),
    isLoading: Record.isRecordLoading(accountSettings.recordChangePassword),
    confirmPassword,
    newPassword,
    id
  };
};

const mapDispatch = (dispatch) => {
  return bindActionCreators(accountSettingsActions, dispatch);
};

export default withRouterV6(connect(mapState, mapDispatch)(UpdatePassword));
